import {
  DailyVideo,
  useScreenVideoTrack,
  useVideoTrack,
} from '@daily-co/daily-react';
import { OtherParticipantNotAvailable } from './ParticipantNotAvailable';
import { CallStatusBadge } from './CallStatusBadge';

export const RemoteParticipantVideoFeed = ({
  participantSessionId,
  participantName,
  participantProfilePicture,
  endTime,
  isFill,
}: {
  participantSessionId: string;
  participantName: string;
  participantProfilePicture: string;
  endTime: Date;
  isFill: boolean;
}) => {
  const { isOff, track } = useVideoTrack(participantSessionId);
  const { isOff: screenIsOff } = useScreenVideoTrack(participantSessionId);

  if (isOff || !track) {
    return (
      <>
        <CallStatusBadge
          endtime={endTime}
          name={participantName}
          sessionId={participantSessionId}
        />
        <OtherParticipantNotAvailable
          message="Has their video turned off"
          participantName={participantName}
          participantProfilePicture={participantProfilePicture}
        />
      </>
    );
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <CallStatusBadge
        endtime={endTime}
        name={participantName}
        sessionId={participantSessionId}
      />
      <DailyVideo
        fit={isFill ? 'cover' : 'contain'}
        automirror={screenIsOff ? true : false}
        sessionId={participantSessionId}
        type={screenIsOff ? 'video' : 'screenVideo'}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};
